import { render, staticRenderFns } from "./goart-mobile-outsite-app.vue?vue&type=template&id=7c4b738c"
import script from "./goart-mobile-outsite-app.vue?vue&type=script&lang=js"
export * from "./goart-mobile-outsite-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GoArtHeaderBar: require('/root/builds/BuRzTR46/0/fotor-mobile/frontend/fotor-h5-website/components/goart/mobile/GoArtHeaderBar.vue').default,GoArtOpenInApp: require('/root/builds/BuRzTR46/0/fotor-mobile/frontend/fotor-h5-website/components/goart/mobile/GoArtOpenInApp.vue').default,GoArtFullLoading: require('/root/builds/BuRzTR46/0/fotor-mobile/frontend/fotor-h5-website/components/goart/mobile/loading/GoArtFullLoading.vue').default,GoArtDialogMsg: require('/root/builds/BuRzTR46/0/fotor-mobile/frontend/fotor-h5-website/components/goart/mobile/GoArtDialogMsg.vue').default,GoArtToast: require('/root/builds/BuRzTR46/0/fotor-mobile/frontend/fotor-h5-website/components/goart/mobile/GoArtToast.vue').default,GoArtConfirm: require('/root/builds/BuRzTR46/0/fotor-mobile/frontend/fotor-h5-website/components/goart/mobile/GoArtConfirm.vue').default})
